import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import Loader from './../../shared/loader'
import CryptoJS from 'crypto-js';
import csvHelper from '../importCSVHelper';
import download from 'downloadjs';
import moment from 'moment';

import {
	Validator
} from 'vee-validate'
export default {
	name: 'importRackId',
	components: {
		Loader,
		download
	},
	data: function() {
		return {
			file: '',
			error_message: '',
			success_message: '',
			failed_messge: '',
			failed_seen: false,
			error_seen: false,
			success_seen: false,
			showOtherDetails:false,
			csv_config: [],
			rejectedList: [],
			isLoading: false,
			listDataCsv: [],
			csvFields: [],
			user_type: '',
			useremail: '',
			client: '',
			clientid: '',
			listClientData: [],
			showSelectClient: false,
			ClientErr: '',
			warehouse: '',
			listWarehouseData: [],
			warehouseid: '',
			checkuserforclientlist: 0,
			checkuserforwarehouselist: 0,
			checkifwarehouseselected: 0,
			resetcheck: 0,
		}
	},
	created: function() {},
	mounted() {
		this.resetcheck = 0;
		var userdetailEncrypt = window.localStorage.getItem('userdetail');
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext)
		this.user_type = userdetail.utype;
		this.useremail = userdetail.email;
		// this.clientid = '';
		this.client = window.localStorage.getItem('selectedClient')
		this.warehouse = window.localStorage.getItem('selectedWarehouse')
		this.warehouseid= this.warehouse
		this.clientid =this.client
		switch (this.user_type) {
			case 'system_user':
				this.resetcheck = 1;
				this.showSelectClient = true;
				this.clientid = '';
				this.checkuserforclientlist = 1;
				this.checkuserforwarehouselist = 1;
				// this.getClientList();
				// this.getWarehouseList();
				break;

			case 'warehouse_user':
				this.showSelectClient = true;
				this.checkifwarehouseselected = 1;
				this.checkuserforclientlist = 1;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.clientid = '';
				// this.getClientList();
				break;

			case 'client_user':
				this.resetcheck = 1;
				this.checkuserforwarehouselist = 1;
				this.clientid = userdetail.clientid;
				// this.getWarehouseList();
				break;

			default:
				this.$alertify.error(this.$t('common.unauthorisedError'));
				break
		}
	},
	methods: {
		// getClientList() {
		// 	if (window.localStorage.getItem("clientList") !== null) {
		// 		var clientListEncrypt = window.localStorage.getItem('clientList');
		// 		var clientbytes = CryptoJS.AES.decrypt(clientListEncrypt.toString(), 'Key');
		// 		var plaintextclient = clientbytes.toString(CryptoJS.enc.Utf8);
		// 		this.listClientData = JSON.parse(plaintextclient);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken');
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.input = ({
		// 			warehouseid: this.warehouseid,
		// 		});
		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr,
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listClientData = result.data.data;
		// 			}, error => {
		// 				console.error(error);
		// 			});
		// 	}
		// },
		// clientSelected() {
		// 	if (this.clientid != this.client) {
		// 	this.clientid = this.client;
	    //  	this.showOtherDetails = true;
		// 	 this.getWarehouseList();
		// 	 if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
		// 		this.warehouse = this.warehouseid = '';
		// 	  }
		// 	}
		// 	this.clientid = this.client;
		// 	if (this.clientid) {
		// 	  if (this.warehouseid == '') {
		// 		this.getWarehouseList();
		// 	  }
		// 	}
		// },
		submitFile() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			if (this.file == '' || (this.$refs.file.files[0].type != 'text/csv' && this.$refs.file.files[0].type != 'application/vnd.ms-excel')) {
				let uploadFileExtension = this.$refs.file.files[0];
				if (/\.(csv|ms-excel|CSV)$/i.test(uploadFileExtension.name)) {
					//do nothing
					console.log(uploadFileExtension.name, "=====================Valid Extension====================");
				} else {
					this.$alertify.error(this.$t('productLogReport.selectCSVFile'));
					return false;
					console.log(uploadFileExtension.name, "=====================InValid Extension====================");
				}
			}
			this.isLoading = true;
			if (document.getElementById('downloadBtn'))
				document.getElementById('downloadBtn').disabled = false;
			var formData = new FormData();

			formData.append('csv', this.file);
			formData.append('warehouseid', window.localStorage.getItem('selectedWarehouse'));
			formData.append('clientid', window.localStorage.getItem('selectedClient'));
			formData.append('useremail', this.useremail);
			axios.post(apiUrl.api_url + 'uploadSRWise',
					formData, {
						headers: {
							'Authorization': 'Bearer ' + myStr,
							'Content-Type': 'multipart/form-data'
						}
					})
				.then((response) => {
					this.file = ''
					document.getElementById('file').value = '';
					response = response.data.data[0];
					if (response.status == true) {
						this.success_seen = true;
						this.error_message = '';
						this.failed_messge = '';
						this.failed_seen = false;
						this.error_seen = false;
						this.csv_config = response.data.csv_config;

						this.success_message = response.data.total_items_created.length + " SR added successfully";

						//  this.error_message = response.data.total_items_updated.length + " SR updated successfully";
						//  this.error_seen = true;
						//  this.rejectedList = response.data.total_items_updated;

						this.failed_seen = true;
						this.rejectedList = response.data.total_items_rejected;
						this.failed_messge = response.data.total_items_rejected.length + " SR Creation failed";
					} else {
						this.error_seen = true;
						this.error_message = response.failure_reason;
						this.success_message = '';
					}
					this.isLoading = false;
				})
				.catch(function() {
					this.error_seen = true;
					this.success_seen = false;
					this.error_message = this.$t('productLogReport.fileUploadErr');
					this.success_message = '';
					this.isLoading = false;
				});
		},
		downloadCSV() {
			document.getElementById('downloadBtn').disabled = true;
			this.isLoading = true;
			if (this.rejectedList.length > 0) {
				let csvFields = [];
				let csvArr = [];

				this.csv_config.forEach(function(field) {
					csvArr.push(field.db_col_name);
					csvFields.push({
						'fieldIndex': field.csv_col_name,
						'fieldColumn': field.db_col_name,
						'fieldName': this.$t(`importCsv.${field.db_col_name}`)
					});
				},this);
				// Add last column for reason
				csvArr.push("failure_reason");
				csvFields.push({
					'fieldIndex': csvFields.length - 1,
					'fieldColumn': "failure_reason",
					'fieldName': this.$t(`importCsv.${'failurereason'}`)
				})

				var dateFilder = [];
				var skipFilter = [];
				var csvResult = [];

				this.rejectedList.forEach(function(item) {
					var rowData = [];
					for (let i = 0; i < csvArr.length; i++) {
						if (item[csvArr[i]])
							rowData[csvArr[i]] = item[csvArr[i]]
						else
							rowData[csvArr[i]] = ''
					}
					csvResult.push(rowData);
				});

				csvHelper.data.jsonToCSV(this.$t('importCsv.srFailure'), csvResult, csvFields, dateFilder, skipFilter);
				this.isLoading = false;
			}
		},

		downloadTemplate() { 
			if(window.localStorage.getItem('selectedClient')==='undefined'){
				this.$alertify.error(this.$t('common.clientError'))
			}

			else if(window.localStorage.getItem('selectedWarehouse')==='undefined'){
				this.$alertify.error(this.$t('common.warehouseError'))
			}
			else{
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getSRCreationTemplete',
					'data': {
						'warehouseid': window.localStorage.getItem('selectedWarehouse'),
						'clientid': window.localStorage.getItem('selectedClient'),
						'type': 'Load_SR'
					},
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then((result) => {
					console.log(this.warehouseid)
					if (result.data.data[0].status) {
						let templateResult = [];
						result.data.data[0].data.forEach(function(field) {
							templateResult.push({
								'fieldIndex': field.csv_col_name,
								'fieldColumn': this.$t(`importCsv.${field.db_col_name}`)
							});
						},this);
						this.jsonToCSV(this.$t('importCsv.srTemplate'), [], templateResult, [], []);
					} else {
						this.$alertify.error(result.data.data[0].msg);
						return false;
					}
				})
			}	
		},
		jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
			//  var data = this.listStockReportData;
			var csvData = ''
			//Header
			if (this.title != null) {
				csvData += this.parseExtraData(this.title, '${data}\r\n')
			}
			//Fields Names
			csvfield.forEach(function(fields) {
				if (skipFilter.indexOf(fields.fieldColumn) == -1) {
					csvData += fields.fieldColumn + ','
				}
			});

			csvData = csvData.slice(0, csvData.length - 1)
			csvData += '\r\n'
			// CSV Data
			data.map(function(item) {
				var i = 0;
				var escapedCSV = ''
				for (let key in item) {
					if (skipFilter.indexOf(key) == -1) {
						escapedCSV = item[key] + '' // cast Numbers to string
						if (escapedCSV.match(/[,"\n]/)) {
							escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
						}
						if (escapedCSV == 'null')
							csvData += ',';
						else {
							if (dateFilder.indexOf(key) != -1)
								csvData += moment(escapedCSV).format('DD-MM-YY HH:mm:ss') + ','
							else
								csvData += escapedCSV + ','
						}
					}
					i++;
				}
				csvData = csvData.slice(0, csvData.length - 1)
				csvData += '\r\n'
			})
			//Footer
			if (this.footer != null) {
				csvData += this.parseExtraData(this.footer, '${data}\r\n')
			}
			filename += moment().format('DD-MM-YY HH:mm:ss') + '.csv';
			return this.export(csvData, filename, "application/csv");
			return csvData
		},
		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},
		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},
		resetFrom() {
			document.getElementById('file').value = '';
			this.error_seen = false;
			this.success_seen = false;
			this.rejectedList = [];
			this.failed_seen = false;
			this.failed_messge = ''
			this.file = ''
			this.showOtherDetails=false

			this.warehouse = '';
			if (this.resetcheck == 1) {
				this.checkifwarehouseselected = 0;
			}
			if(this.user_type!='client_user'){
				this.client = '';
				this.clientid = '';
			}


		},
		// getWarehouseList() {
		// 	if (window.localStorage.getItem("warehouseList") !== null) {
		// 		var warehouseListEncrypt = window.localStorage.getItem('warehouseList');
		// 		var warehousebytes = CryptoJS.AES.decrypt(warehouseListEncrypt.toString(), 'Key');
		// 		var plaintextwarehouse = warehousebytes.toString(CryptoJS.enc.Utf8);
		// 		this.listWarehouseData = JSON.parse(plaintextwarehouse);
		// 	} else {
		// 		var userToken = window.localStorage.getItem('userToken')
		// 		var myStr = userToken.replace(/"/g, '');
		// 		this.pageno = 0;
		// 		this.input = ({
		// 			'clientid': this.clientid,
		// 		});
		// 		axios({
		// 				method: 'POST',
		// 				'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
		// 				'data': this.input,
		// 				headers: {
		// 					'Authorization': 'Bearer ' + myStr
		// 				}
		// 			})
		// 			.then(result => {
		// 				this.listWarehouseData = result.data.data;
		// 			}, error => {
		// 				console.error(error)
		// 			})
		// 	}
		// },

		// warehouseSelected() {
		// 	this.warehouseid = this.warehouse;
		// 	this.showOtherDetails=true
		// 	if (this.warehouseid != '') {
		// 		this.checkifwarehouseselected = 1;
		// 	}
		// },

		handleFileUpload() {
			this.file = this.$refs.file.files[0];

		}
	}
}


// WEBPACK FOOTER //
// ./src/views/components/importCSV/importSR/importSR.component.js